/*
 * Module for the ACH File Vendor job criteria page
 */
rs.module("content/jobs/criteria/achfilevendor",

    ["controls/data/grid"],

    function (gridModule) {

        function initialize(jsSelectors, backendUrl, lrsGridApi) {

            var criteria = $.js(jsSelectors.criteria);

            var createRecreateLoadingSpinner = criteria.js(jsSelectors.createRecreateLoadingSpinner);
            var createRecreateRadioContainer = criteria.js(jsSelectors.createRecreateRadioContainer);

            // Register click event for create/recreate radio buttons to control grid display
            createRecreateRadioContainer.find("input").on("click", onCreateRecreateToggle);

            // Handle population of grid on createRecreateRadio toggle
            function onCreateRecreateToggle() {
                var isRecreate = createRecreateRadioContainer.find("input:checked").val() == "true";

                createRecreateLoadingSpinner.show();

                gridModule.update(
                    backendUrl,

                    { recreate: isRecreate },

                    lrsGridApi.agGridApi,

                    function done() {
                        createRecreateLoadingSpinner.hide();
                    }
                );
            }
        }

        var exports = {
            initialize: initialize
        };

        return exports;
    }
);